import React from 'react';
import { designSystem } from '@yola/ws-ui';
import GoogleAnalyticsIntegrationContainer from '../../integrations/containers/google-analytics-integration-container';
import GoogleSearchConsoleIntegrationContainer from '../../integrations/containers/google-search-console-integration-container';
import CookiebotIntegrationContainer from '../../integrations/containers/cookiebot-integration-container';
import constants from '../constants';
import { useWebsiteSettingsContext } from '../context/website-settings-context';

const { tabIdentifiers } = constants;
const { Stack, Paragraph } = designSystem;

function IntegrationsSection() {
  const {
    captions: { integrations: captions },
    formValues: form,
    initialValues,
    showPromptForce = false,
  } = useWebsiteSettingsContext();

  return (
    <div>
      <Stack gap="spacing-xs">
        <Paragraph appearance="medium-emphasis" size="small">
          {captions.description}
        </Paragraph>
        <GoogleAnalyticsIntegrationContainer
          captions={captions.googleAnalytics}
          form={form}
          activeTabId={tabIdentifiers.INTEGRATIONS}
          initialValues={initialValues}
          showPromptForce={showPromptForce}
        />
        <GoogleSearchConsoleIntegrationContainer
          captions={captions.googleSearchConsole}
          form={form}
          activeTabId={tabIdentifiers.INTEGRATIONS}
          initialValues={initialValues}
          showPromptForce={showPromptForce}
        />
        <CookiebotIntegrationContainer
          captions={captions.cookiebot}
          form={form}
          activeTabId={tabIdentifiers.INTEGRATIONS}
          initialValues={initialValues}
          showPromptForce={showPromptForce}
        />
      </Stack>
    </div>
  );
}

export default IntegrationsSection;
